/* Amalife — cookie consent.
   The banner is only a front end for Shopify's Customer Privacy API: every
   choice is written with setTrackingConsent, which is what actually gates
   Shopify's pixels and any consent-aware app. Nothing here decides on its own
   whether to track. */
(function () {
  'use strict';

  var box = document.querySelector('[data-ama-consent]');
  if (!box) return;

  var saving = false;
  var saveAttempt = 0;
  var errorBox = box.querySelector('[data-ama-consent-error]');

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function loadApi() {
    return new Promise(function (resolve) {
      if (api()) return resolve(api());
      if (!window.Shopify || !window.Shopify.loadFeatures) return resolve(null);
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { resolve(error ? null : api()); }
      );
      setTimeout(function () { resolve(api()); }, 4000);
    });
  }

  function show() {
    syncCategories();
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-in'); });
  }

  function hide() {
    box.classList.remove('is-in');
    setTimeout(function () { box.hidden = true; }, 250);
  }

  function hasNativeBanner() {
    return !!(
      window.privacyBanner &&
      typeof window.privacyBanner.showPreferences === 'function'
    );
  }

  function waitForNativeBanner() {
    return new Promise(function (resolve) {
      var checks = 0;
      var timer = setInterval(function () {
        checks += 1;
        if (hasNativeBanner() || checks >= 12) {
          clearInterval(timer);
          resolve(hasNativeBanner());
        }
      }, 100);
    });
  }

  function syncCategories() {
    var cp = api();
    var current = {};
    try { current = cp.currentVisitorConsent(); } catch (e) {}
    box.querySelectorAll('[data-ama-consent-cat]').forEach(function (input) {
      input.checked = current[input.getAttribute('data-ama-consent-cat')] === 'yes';
    });
  }

  function showError() {
    if (!errorBox) return;
    errorBox.textContent = (window.amaI18n && window.amaI18n.consent_error || 'Изборът не беше потвърден. Моля, опитай отново.');
    errorBox.hidden = false;
  }

  function save(consent) {
    var cp = api();
    if (saving) return;
    if (!cp || !cp.setTrackingConsent) { showError(); return; }
    saving = true;
    var attempt = ++saveAttempt;
    if (errorBox) errorBox.hidden = true;
    var timeout = setTimeout(function () {
      if (attempt !== saveAttempt) return;
      saveAttempt++;
      saving = false;
      showError();
    }, 5000);
    function complete(result) {
      if (attempt !== saveAttempt) return;
      clearTimeout(timeout);
      saveAttempt++;
      saving = false;
      if (result && result.error) { showError(); return; }
      syncCategories();
      hide();
    }
    function consentWasSaved() {
      var current = {};
      try { current = cp.currentVisitorConsent(); } catch (e) { return false; }
      return (
        current.marketing === (consent.marketing ? 'yes' : 'no') &&
        current.analytics === (consent.analytics ? 'yes' : 'no') &&
        current.preferences === (consent.preferences ? 'yes' : 'no')
      );
    }
    try { cp.setTrackingConsent(
      {
        marketing: !!consent.marketing,
        analytics: !!consent.analytics,
        preferences: !!consent.preferences
      },
      complete
    ); } catch (error) { complete({ error: error }); }

    // Some embedded mobile browsers persist Shopify's consent but never invoke
    // the callback. Confirm the saved values directly so the fallback banner
    // still closes instead of showing a false error.
    [250, 750, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        if (attempt !== saveAttempt || !saving) return;
        if (consentWasSaved()) complete({});
      }, delay);
    });
  }

  function chosenCategories() {
    var out = { analytics: false, marketing: false, preferences: false };
    box.querySelectorAll('[data-ama-consent-cat]').forEach(function (input) {
      out[input.getAttribute('data-ama-consent-cat')] = input.checked;
    });
    return out;
  }

  box.addEventListener('click', function (event) {
    var t = event.target;

    if (t.closest('[data-ama-consent-accept]')) {
      save({ analytics: true, marketing: true, preferences: true });
      return;
    }
    if (t.closest('[data-ama-consent-reject]')) {
      save({ analytics: false, marketing: false, preferences: false });
      return;
    }
    if (t.closest('[data-ama-consent-save]')) {
      save(chosenCategories());
      return;
    }
    if (t.closest('[data-ama-consent-toggle]')) {
      var toggle = t.closest('[data-ama-consent-toggle]');
      var prefs = box.querySelector('[data-ama-consent-prefs]');
      var saveBtn = box.querySelector('[data-ama-consent-save]');
      var open = prefs.hidden;
      prefs.hidden = !open;
      saveBtn.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    }
  });

  /* Reopening: any link or button with data-ama-consent-open lets the shopper
     change their mind later, which GDPR requires. Put one in the footer. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-ama-consent-open]')) return;
    event.preventDefault();
    if (hasNativeBanner()) {
      window.privacyBanner.showPreferences();
      return;
    }
    show();
  });

  document.addEventListener('visitorConsentCollected', hide);

  Promise.all([loadApi(), waitForNativeBanner()]).then(function (results) {
    var cp = results[0];
    if (results[1]) {
      hide();
      return;
    }
    if (!cp) { show(); showError(); return; }
    var needed = true;
    try {
      if (typeof cp.shouldShowBanner === 'function') needed = cp.shouldShowBanner();
      else if (typeof cp.shouldShowGDPRBanner === 'function') needed = cp.shouldShowGDPRBanner();
    } catch (e) {}
    // Shopify owns consent expiry. A permanent localStorage marker must not
    // suppress a new choice after consent expires or is reset.
    if (needed) show();
  });
})();
